<template>
  <div id="main">
    <div class="rightTopButton">
      <el-form size="small" :inline="true" :model="formSearch" class="demo-form-inline" style="text-align: right;">
        <el-form-item style="float: left">
          <el-button size="small" @click="formAdd()" type="primary" plain>新增</el-button>
        </el-form-item>
        <el-form-item label="用户名">
          <el-input v-model="formSearch.userName" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item label="UK名称">
          <el-input v-model="formSearch.ukName" placeholder="UK名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitSearch">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="rightContent" style="height: calc(100% - 60px)">
      <el-table
        border
        stripe
        size="small"
        ref="singleTable"
        :header-cell-style="{background:'#ECF5FF',color:'#606266'}"
        :data="tableData"
        :highlight-current-row="true"
        height="100%"
        style="width: 100%">
        <el-table-column property="userName" align="center" label="用户名称" width="260"></el-table-column>
        <el-table-column property="ukName" align="center" label="UK名称" width="260"></el-table-column>
        <el-table-column property="ukCode" align="center" label="UK编码" width="380"></el-table-column>
        <el-table-column property="sortNum" align="center" label="排序号" width="100"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              icon="el-icon-edit"
              title="编辑"
              circle
              plain
              @click="formEdit(scope.$index, scope.row)"></el-button>
            <el-button
              size="mini"
              type="danger"
              icon="el-icon-delete"
              title="删除"
              circle
              plain
              @click="formDelete(scope.$index, scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog title="UK信息管理" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
      <el-form :model="dataForm" :rules="rules" ref="dataForm">
        <el-row>
          <el-col>
            <el-form-item label="用户名称" :label-width="formLabelWidth">
              <el-input v-model="dataForm.userName" placeholder="用户名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="UK名称" :label-width="formLabelWidth">
              <el-input v-model="dataForm.ukName" placeholder="UK名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="UK编码" :label-width="formLabelWidth" prop="ukCode">
              <el-input v-model="dataForm.ukCode" placeholder="UK编码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="排序号" :label-width="formLabelWidth" prop="orderNo">
              <el-input v-model="dataForm.sortNum" placeholder="排序号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="formSave('dataForm')">确 定</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'UkManage',
  data () {
    var checkNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('排序号不能为空且大于0'))
      }
      setTimeout(() => {
        if (!Number.isInteger(parseInt(value))) {
          callback(new Error('排序号为数值'))
        } else {
          callback()
        }
      }, 100)
    }
    return {
      tableData: [],
      dialogFormVisible: false,
      dataForm: {},
      formSearch: {},
      formLabelWidth: '120px',
      total: 0,
      rows: 15,
      currentPage: 1,
      selectResourceId: '',
      rules: {
          ukCode: [
          { required: true, message: '请输入UK编码', trigger: 'blur' },
          { min: 1, max: 40, message: '长度在 1 到 40 个字符之间', trigger: 'blur' }
        ],
        sortNum: [
          { validator: checkNum, trigger: 'blur' }
        ]
      }
    }
  },
  mounted: function () {
      this.getList();
  },
  methods: {
    handleSizeChange (val) {
      this.rows = val
      this.currentPage = 1
      this.getList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },
    submitSearch: function () {
        this.getList();
    },
    getList: function () {
      this.$axios.get(
        this.$idmConfig.ukManage.ListUrl + '?t=' + new Date().getTime(),
        {
            params: this.formSearch
        }
      ).then(data => {
        if (data.data.succeed) {
          this.tableData = data.data.data
        } else {
          this.$message({
            message: data.data.msg,
            showClose: true,
            type: 'error'
          })
        }
      })
    },
    formAdd () {
      if (this.$refs.dataForm) {
        this.$refs.dataForm.clearValidate()
      }
      this.dataForm={
        id:"",
        userName: '',
        ukName: '',
        ukCode: '',
        sortNum: 1,
      };
      this.dialogFormVisible = true
    },
    formSave (dataForm) { // 保存
      this.$refs[dataForm].validate((valid) => {
        if (valid) {
          this.$axios.post(
            this.$idmConfig.ukManage.addUrl,
            this.$qs.stringify({jsonData:JSON.stringify(this.dataForm)})
          ).then(data => {
            if (data.data.succeed) {
              this.dialogFormVisible = false
              this.getList()
            } else {
              this.$message({
                message: data.data.msg,
                showClose: true,
                type: 'error'
              })
            }
          })
        } else {
          return false
        }
      })
    },
    formEdit (index, row) {
      if (this.$refs.dataForm) {
        this.$refs.dataForm.clearValidate()
      }
      this.dataForm = row
      this.dialogFormVisible = true
    },
    formDelete (index, row) {
      this.$confirm('确认删除该项信息?', '提示', {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(
          this.$idmConfig.ukManage.deleteUrl,
          this.$qs.stringify({id: row.id})
        ).then(data => {
          if (data.data.succeed) {
            this.getList()
          } else {
            this.$message({
              message: data.data.msg,
              showClose: true,
              type: 'error'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          showClose: true,
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#main{
  height: 100%;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.rightTopButton {
  text-align: left;
  padding-top: 10px;
  padding-left: 10px;
}
.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/UkManage.vue